
import { DefaultWebClientMethod, NoInputWebClientMethod } from '../requester/webClientMethod';
import { WebClientApiResponse } from './WebClientApiResponse';

export class VizPortalClientMethod<TParams, TResult> extends DefaultWebClientMethod<TParams, WebClientApiResponse<TResult>> {

  public isValidOutput(output?: WebClientApiResponse<TResult>): boolean {
    return super.isValidOutput(output) && !!output && !!output.result;
  }
}

export class NoInputVizPortalClientMethod<TResult> extends NoInputWebClientMethod<WebClientApiResponse<TResult>> {

  public isValidOutput(output?: WebClientApiResponse<TResult>): boolean {
    return super.isValidOutput(output) && !!output && !!output.result;
  }

}
